export default __webpack_public_path__ + "static/media/horizontales-HC2.8e33b0bc.jpg";